import type { ApiFetchFavoriteGamesPort } from '~/handlers/ports/api-fetch-favorite-games.port';
import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';
import { getApostatudoRequestHeaders } from '~/utils/apostatudo/get-apostatudo-request-headers';

export class ApostatudoApiFetchFavoriteGamesAdapter
  implements ApiFetchFavoriteGamesPort
{
  private timeout = 8000; // 8 segundos

  async handle(playerId: string) {
    try {
      // ENG-497: o core resolve o jogador pelo Bearer (gate EnsureUserTokenIdentity);
      // o playerId sai da URL e só é usado pra montar o player_code do retorno.
      const url = `${getApostatudoApiUrl()}/favorite-games`;

      // Adiciona timeout à requisição
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), this.timeout);

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          ...getApostatudoRequestHeaders(),
        },
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      if (!response.ok) {
        console.warn(
          `API retornou status ${response.status} ao buscar favoritos`,
        );

        return null;
      }

      const data = await response.json();

      // Se a API retornou um array diretamente
      if (Array.isArray(data)) {
        return {
          player_code: playerId,
          payload: data,
        };
      }

      // Se a API retornou { data: [...] } em vez de { payload: [...] }
      if (data.data && !data.payload) {
        return {
          player_code: playerId,
          payload: data.data,
        };
      }

      return data;
    } catch (error) {
      if (error instanceof Error) {
        if (error.name === 'AbortError') {
          console.error('Timeout ao buscar favoritos - API demorou muito');
        } else {
          console.error('Erro ao buscar favoritos na API:', error.message);
        }
      }

      return null;
    }
  }
}
